import { getUserProfile } from "../../services/user";

const state = {
   isWithdrawMenu: false,
   userToken: JSON.parse(localStorage.getItem('userToken')) || '',
   myCenterMenuIndex: 0,
   userProfile: JSON.parse(localStorage.getItem('userProfile')) || '',
   realNameAuthInfo:{},
   orderInfoToIm: [] //JSON.parse(localStorage.getItem('orderInfoToIm')) ||
}
const mutations = {

   //保存用户token
   saveUserToken(state, payload) {
      state.userToken = payload.token;
      localStorage.setItem('userToken', JSON.stringify(payload.token))
   },
   setUserProfileForKycStatus(state,payload){
      state.userProfile.kycStatus = payload;
      localStorage.setItem('userProfile', JSON.stringify(state.userProfile))
   },
   //保存用户资料
   setUserProfile(state, payload) {
      state.userProfile = payload;
      localStorage.setItem('userProfile', JSON.stringify(payload))
   },
   //设置实名认证信息
   setRealNameAuthInfo(state,payload){
      state.realNameAuthInfo = payload;
   },
   //用户退出操作
   clearUserProfile(state, payload) {
      //console.log("clearUserProfile===")
      state.userToken = null;
      state.userProfile = null;
      localStorage.removeItem('userToken');
      localStorage.removeItem('userProfile');
   },
   // 个人中心设置基本信息是否显示余额卡
   setIsWithdrawMenu(state, payload) {
      //console.log('当前payload是：'+payload)
      state.isWithdrawMenu = payload;
   },
   //个人中心菜单
   setMyCenterMenuIndex(state, payload) {
      state.myCenterMenuIndex = payload;
   }, 
   //设置订单状态，为了让im系统同步
   setOrderInfoToIm(state, payload){
      let tempObj = state.orderInfoToIm&&state.orderInfoToIm.find(item =>item.productId===payload.productId&&item.orderNo===payload.orderNo);
      if(tempObj){
         tempObj.orderStatus = payload.orderStatus;
         localStorage.setItem('orderInfoToIm',JSON.stringify(state.orderInfoToIm));
      }else{
         state.orderInfoToIm.push(payload);
         //console.log(state.orderInfoToIm);
         localStorage.setItem('orderInfoToIm',JSON.stringify(state.orderInfoToIm));
      }
   },
   

}

const actions = {
   async loadUserProfile(context, payload) {
      try {
         const { data } = await getUserProfile();
         if (data.code == 200) {
            context.commit('setUserProfile', data.data)
            return Promise.resolve(200)
         } else {
            return Promise.reject('获取数据失败')
         }
      } catch (err) { }
   }
}

const getters = {

}

export default {
   namespaced: true,
   state,
   mutations,
   actions,
   getters
}